import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getCampaignSummary = payload => api.get('/platform/mainpage-info', payload)

const getCampaigns = payload => api.get('/platform/training-camps', payload)

const getCampaignsStatusTotal = payload =>
  api.get('/platform/training-camps/status-static', payload)

const getCampaignDetails = payload =>
  api.get(`/platform/training-camps/${payload.campaignId}`, payload.params)

const getCampaignUsers = payload =>
  api.get(`/platform/training-camps/users/${payload.campaignId}`, payload.params)

const getCampaignOptions = payload =>
  api.get(`/platform/training-camps/options/${payload.accountId}`, payload)

const sendCampaignReminders = payload =>
  api.post(`/platform/training-camps/notify-email/${payload.campaignId}`, payload.data)

const createCampaign = payload =>
  api.post(`/platform/training-camps?accountId=${payload.accountId}`, payload.data)

export default {
  getCampaignSummary,
  getCampaigns,
  getCampaignsStatusTotal,
  getCampaignDetails,
  getCampaignUsers,
  getCampaignOptions,
  sendCampaignReminders,
  createCampaign,
}
